import { noop } from "lodash";
import { usePaywallApi } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/hooks/usePaywallApi";
import type { UsePaywallApiProps } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/hooks/usePaywallApi";

export interface PaywallActionsProps {
  paywall: UsePaywallApiProps["paywall"];
  refetchPaywalls: () => void;
}

export const usePaywallActions = ({
  paywall,
  refetchPaywalls,
}: PaywallActionsProps) => {
  const { publishMutation, archiveMutation, deleteMutation } = usePaywallApi({
    createCallback: noop,
    updateCallback: refetchPaywalls,
    paywall,
  });

  const publishPaywall = () => publishMutation.mutate();

  const archivePaywall = () => archiveMutation.mutate();

  const deletePaywall = () => deleteMutation.mutate();

  return {
    publishPaywall,
    archivePaywall,
    deletePaywall,
  };
};
